// views
import { Tooltip } from "antd";
import levelIcon from "~/public/static/icons/level.png";

export default (props) => {
  const { level } = props;

  if (!level) {
    return null;
  }

  return (
    <Tooltip placement="top" title={level.name} arrowPointAtCenter>
      <span className="level-badge">
        <img src={levelIcon.src} alt="等级" />
        <span>{level.level}</span>
      </span>
    </Tooltip>
  );
};
